import React, { useState, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { useAlert } from 'react-alert';

const GroupShow = (props) => {
    const [groupData, setGroupData] = useState({ name: '' });
    const [error, setError] = useState({});
    const alert = useAlert();

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setGroupData(current => ({ ...current, [name]: value }));
        setError(current => ({ ...current, testName: '' }));
    }, []);

    const handleSubmit = useCallback(async () => {
        if (!groupData.name.trim()) {
            setError(current => ({ ...current, testName: 'Test Group is required.' }));
            return;
        }

        try {
            const tokenString = sessionStorage.getItem('usertoken');
            const token = tokenString.replace(/["]+/g, '');

            const res = await axios.post(
                `${APIURL}/api/v1/staff/master-test-group/?${TZ}`,
                { group_name: groupData.name },
                { headers: { Authorization: 'Token ' + token } }
            );

            if (res.status === 200 && res.data.status === 'success') {
                alert.success('Group created successfully!');
                props.handleSuccess();
            } else {
                alert.error(res.data.message || 'Failed to create group');
            }
        } catch (err) {
            alert.error('Failed to add test. Please try again.');
        }
    }, [groupData.name, alert, props]);

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            show={true}
        >
            <Modal.Header closeButton onHide={props.onClose}>
                <Modal.Title><b>Add Test Group</b></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ display: "flex" }}>
                <div className='panel-container col-12'>
                    <div className='pricing-inputcontainer' style={{ marginBottom: '10%' }}>
                        <span className='required'>Test Group Name</span>
                        <input
                            className={error.testName ? 'has-error-input' : ''}
                            name="name"
                            placeholder='Test Group Name'
                            value={groupData.name}
                            onChange={handleInputChange}
                        />
                        {error.testName && <div className="error-message">{error.testName}</div>}
                    </div>
                    <div style={{ display: "flex", gap: "10px", margin: "auto 0 0 auto" }}>
                        <button className='add-btn' onClick={props.onClose}>
                            Close
                        </button>
                        <button className='add-btn' onClick={handleSubmit}>
                            Save
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default React.memo(GroupShow);